// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3095) return "css/3095-5ffb66e7.css";
	// return url for filenames based on template
	return "css/" + chunkId + "-" + "4cac56f1" + ".css";
};